import { Snapshot } from "../../types";
import styled from "styled-components";

const SnapshotDownloadLink = styled.span`
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary};
  &:hover {
    color: ${(props) => props.theme.colors.light};
    transition: all 150ms;
  }
`;

const SnapshotDownload = ({
  snapshotData,
  id,
}: {
  snapshotData: Snapshot[] | undefined;
  id: string | undefined;
}) => {
  const exportData = () => {
    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify(snapshotData)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `${id}.json`;
    link.click();
  };

  return (
    <SnapshotDownloadLink onClick={exportData}>
      Download Snapshot Data
    </SnapshotDownloadLink>
  );
};

export default SnapshotDownload;
